module.exports = __webpack_public_path__ + "media/images/area/travel-tips-25e6d71b912f436ee1f26e56b3497043.jpg";